/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnDestroy, type OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '@dm/core';
import { GlobalDataService } from 'app/common/services';
import { SWITCH } from 'app/config';
import { type Subscription } from 'rxjs';

import { AlarmsAndEventsStrService } from '../alarms-and-events-str.service';

@Component({
    selector: 'app-anomaly-panel',
    templateUrl: './anomaly-panel.component.html',
    styleUrls: ['./anomaly-panel.component.scss'],
})
export class AnomalyPanelComponent implements OnInit, OnDestroy {
    total = 0;
    $getAnomalyCount: Subscription;

    get isSimpleMode(): boolean {
        return SWITCH.IS_SIMPLE_MODE;
    }

    constructor(
        private eventService: EventService,
        private globalDataService: GlobalDataService,
        private router: Router,
        public str: AlarmsAndEventsStrService,
    ) { }

    ngOnInit(): void {
        this.total = this.globalDataService.anomalyCount;
        this.$getAnomalyCount = this.eventService.subscribe('getAnomalyCount', (total) => this.total = total);
    }

    ngOnDestroy(): void {
        this.$getAnomalyCount.unsubscribe();
    }

    /**
     * 跳转到异常检测
     */
     goToPerformanceAnomaly(): void {
        this.router.navigate(['/monitor/performance/performance-anomaly']);
    }
}
